import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

// Collapse wrapper for dashboard widgets: a slim header strip (title + chevron)
// with the widget rendered below it. Avoids overlapping widgets that have their
// own top-right action buttons.
export default function CollapsibleWidget({
  title,
  defaultOpen = true,
  children,
  testId,
  variant = 'default',
  icon: Icon,
}) {
  const [open, setOpen] = useState(defaultOpen);
  const isScenario = variant === 'scenario';
  return (
    <div
      className={isScenario ? 'mb-3 w-full' : 'mb-4'}
      data-testid={testId}
      data-variant={variant}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        data-testid={testId ? `${testId}-toggle` : undefined}
        className={isScenario
          ? `group flex min-h-[56px] w-full items-center justify-between border px-4 py-3 text-left transition-all duration-200 ${
            open
              ? 'rounded-t-xl border-indigo-200 border-b-indigo-100 bg-indigo-50/60 shadow-sm'
              : 'rounded-xl border-slate-200 bg-white shadow-sm hover:-translate-y-px hover:border-indigo-300 hover:bg-indigo-50/40 hover:shadow-md'
          }`
          : `w-full flex items-center justify-between px-4 py-2.5 bg-gray-100 hover:bg-gray-200 border border-gray-200 transition-colors ${open ? 'rounded-t-xl border-b-0' : 'rounded-xl'}`}
      >
        {isScenario ? (
          <>
            <span className="flex min-w-0 items-center gap-3">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-indigo-100 bg-indigo-50 text-indigo-600 transition-colors group-hover:bg-indigo-100">
                {Icon ? <Icon className="h-4 w-4" /> : <span className="h-4 w-1 rounded-full bg-indigo-500" />}
              </span>
              <span className="truncate text-[12px] font-black uppercase tracking-[0.12em] text-slate-700">
                {title}
              </span>
            </span>
            <span className="ml-4 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-slate-50 text-slate-500 transition-colors group-hover:border-indigo-200 group-hover:bg-white group-hover:text-indigo-600">
              {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
            </span>
          </>
        ) : (
          <>
            <span className="text-[11px] font-bold uppercase tracking-wider text-gray-600">{title}</span>
            {open ? <ChevronUp className="h-4 w-4 text-gray-500" /> : <ChevronDown className="h-4 w-4 text-gray-500" />}
          </>
        )}
      </button>
      {open && (
        <div className={isScenario
          ? 'overflow-hidden rounded-b-xl border border-t-0 border-indigo-200 bg-white shadow-sm'
          : 'border border-gray-200 border-t-0 rounded-b-xl overflow-hidden bg-white'}
        >
          {children}
        </div>
      )}
    </div>
  );
}
